// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/altimeter-serviceability-check.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/altimeter-serviceability-check/altimeter-serviceability-check.js';

mount([g0]);
